import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AgrPageDetailModule } from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { LetDirective, PushPipe } from '@ngrx/component';
import { provideEffects } from '@ngrx/effects';

import { OrganicMatterQuickViewComponent } from './organic-matter-quick-view.component';
import { OrganicMatterBalanceEffects } from './store/organic-matter.effects';

@NgModule({
  declarations: [OrganicMatterQuickViewComponent],
  imports: [
    CommonModule,
    AgrPageDetailModule,
    AgrI18nSharedModule,
    LetDirective,
    PushPipe,
    MatIconModule,
  ],
  providers: [provideEffects(OrganicMatterBalanceEffects)],
  exports: [OrganicMatterQuickViewComponent],
})
export class OrganicMatterModule {}
